// The creator name /projects-sync reports for a project nobody created by
// hand — every account's first project, whose creator column takes the system
// user as its database default. The control plane sends this string verbatim
// and it is never translated, so it has to be matched literally.
export const SYSTEM_PROJECT_CREATOR_NAME = "Storytell";

/**
 * Resolves the creator name to put on a project header. A project the system
 * created is labelled with the product name the caller passes in; anybody else
 * is shown under the name the control plane reported for them.
 */
export function projectCreatorLabel(createdByName: string | undefined, systemLabel: string): string {
  if (createdByName === SYSTEM_PROJECT_CREATOR_NAME) return systemLabel;
  return createdByName ?? "";
}
